import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const navItems = [
  { label: 'Video', id: 'video' },
  { label: 'Acompañamiento', id: 'acompanamiento' },
];

export default function ComoFuncionaNavbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 60);
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const goHome = () => {
    navigate('/');
    setMenuOpen(false);
  };

  const goPrecios = () => {
    navigate('/precios');
    setMenuOpen(false);
  };

  const scrollTo = (id: string) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setMenuOpen(false);
  };

  const textClass = scrolled ? 'text-[#0A0A0A]/70 hover:text-[#534AB7]' : 'text-white/80 hover:text-white';

  return (
    <nav className={`fixed left-0 right-0 top-0 z-50 transition-all duration-300 ${scrolled || menuOpen ? 'border-b border-[#AFA9EC]/20 bg-white/95 backdrop-blur-xl' : 'bg-transparent'}`}>
      <div className="mx-auto flex h-20 max-w-7xl items-center justify-between px-6">
        <button onClick={goHome} className="flex items-center cursor-pointer">
          <span className={`font-title text-2xl leading-none transition-colors ${scrolled || menuOpen ? 'text-[#0A0A0A]' : 'text-white'}`}>Cover</span>
          <span className="font-title text-2xl leading-none text-[#AFA9EC]">ly</span>
        </button>

        <div className="hidden items-center gap-8 md:flex">
          <button onClick={goHome} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${textClass}`}>
            Inicio
          </button>
          {navItems.map((item) => (
            <button key={item.id} onClick={() => scrollTo(item.id)} className={`text-sm font-medium transition-colors whitespace-nowrap cursor-pointer ${textClass}`}>
              {item.label}
            </button>
          ))}
          <button onClick={goPrecios} className="rounded-full bg-[#534AB7] px-5 py-2.5 text-sm font-semibold text-white transition-colors hover:bg-[#3C3489] whitespace-nowrap cursor-pointer">
            Ver planes
          </button>
        </div>

        <button className="flex h-10 w-10 items-center justify-center md:hidden cursor-pointer" onClick={() => setMenuOpen((open) => !open)} aria-label="Abrir menú">
          <i className={`text-xl ${scrolled || menuOpen ? 'text-[#534AB7]' : 'text-white'} ${menuOpen ? 'ri-close-line' : 'ri-menu-line'}`} />
        </button>
      </div>

      <div className={`overflow-hidden bg-white/97 backdrop-blur-xl transition-all duration-300 md:hidden ${menuOpen ? 'max-h-96 border-t border-[#AFA9EC]/20' : 'max-h-0'}`}>
        <div className="flex flex-col gap-1 px-6 py-4">
          <button onClick={goHome} className="border-b border-[#AFA9EC]/20 py-3 text-left font-medium text-[#0A0A0A]/70 transition-colors hover:text-[#534AB7] cursor-pointer">
            Inicio
          </button>
          {navItems.map((item) => (
            <button key={item.id} onClick={() => scrollTo(item.id)} className="border-b border-[#AFA9EC]/20 py-3 text-left font-medium text-[#0A0A0A]/70 transition-colors hover:text-[#534AB7] cursor-pointer">
              {item.label}
            </button>
          ))}
          <button onClick={goPrecios} className="mt-3 rounded-full bg-[#534AB7] px-6 py-3 font-semibold text-white whitespace-nowrap cursor-pointer">
            Ver planes
          </button>
        </div>
      </div>
    </nav>
  );
}
